import { axiosClient } from 'lib/axios'
import { WorkdayEmployeeUpdateFailure } from './types'

export const getWorkdayEmployeeUpdateFailures = async () => {
  const response = await axiosClient.get<WorkdayEmployeeUpdateFailure[]>(
    '/diagnostics/workday/employee_updates/failures',
  )
  return response.data
}
